<script setup lang="ts">
// components
import CiModalFooter from '@/components/CiModal/CiModalFooter.vue';
import CiModalHeader from '@/components/CiModal/CiModalHeader.vue';

export interface CiModalSuccessProps {
  buttons?: any;
  closeable?: boolean;
  successMessage?: string | null;
  title?: string | null;
  warnings?: any | null;
}
const props = withDefaults(defineProps<CiModalSuccessProps>(), {
  buttons: () => [],
  closeable: true,
  successMessage: null,
  title: null,
  warnings: () => [],
});

const emit = defineEmits<{
  close: [];
}>();

/********************
 * COMPOSITIONS      *
 ********************/
const { $gettext } = useGettext();

const internalSuccessMessage = computed(() => {
  if (props.successMessage) {
    return props.successMessage;
  }
  return $gettext('Thank you. Your operation has been completed successfully.');
});
</script>

<template>
  <div class="rounded bg-white shadow-2xl">
    <CiModalHeader
      :title="props.title"
      :closeable="props.closeable"
      @modal-close="props.closeable ? emit('close') : false"
    />
    <div class="container-fluid mt-4 px-4 py-6" data-cy="ci-modal-success">
      <CiSuccess :message="internalSuccessMessage" />
      <template
        v-if="props.warnings?.length"
      >
        <div class="my-1 text-center text-warning">
          <span class="font-medium">{{ $gettext('Warning!') }}</span>
        </div>
        <div
          v-for="(warning, index) in props.warnings"
          :key="`${index}-${warning}`"
          class="mb-2 text-center text-warning"
        >
          {{ warning }}
        </div>
      </template>
    </div>
    <CiModalFooter
      v-if="props.buttons?.length"
      class="flex justify-center p-4"
    >
      <div
        v-for="(button, index) in props.buttons"
        :key="`${index}-${button.label}`"
      >
        <CiButton
          v-if="button.to"
          tag="NuxtLink"
          :variant="button.variant"
          :class="button.classes"
          :to="button.to"
          @click="emit('close')"
        >
          {{ button.label }}
        </CiButton>
        <CiButton
          v-if="button.onClick"
          tag="button"
          :variant="button.variant"
          :class="button.classes"
          @click="button.onClick"
        >
          {{ button.label }}
        </CiButton>
      </div>
    </CiModalFooter>
  </div>
</template>
